import * as React from 'react'
import type { SVGProps } from 'react'
const SvgApplePodcast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.75 2A8.75 8.75 0 0 0 3 10.75a8.748 8.748 0 0 0 5.29 8.035c-.137-.81-.242-1.625-.274-2.271a6.871 6.871 0 0 1-3.141-5.764 6.883 6.883 0 0 1 6.875-6.875 6.883 6.883 0 0 1 6.875 6.875c0 2.414-1.253 4.535-3.14 5.766-.033.644-.139 1.46-.275 2.272a8.7505 8.7505 0 0 0 2.0692-14.8218A8.75 8.75 0 0 0 11.75 2m0 12.188c-1.284 0-2.5.336-2.5 1.708 0 1.295.503 4.075.806 5.188.202.744.956.916 1.694.916s1.494-.17 1.694-.913c.302-1.122.806-3.9.806-5.189 0-1.375-1.215-1.71-2.5-1.71m0-1.25a2.1865 2.1865 0 0 0 2.022-1.3504 2.19 2.19 0 0 0 .166-.8376c0-1.209-1.012-2.188-2.188-2.188s-2.188.977-2.188 2.188c0 1.21.977 2.188 2.188 2.188m5.625-2.188a5.625 5.625 0 1 0-11.25 0c0 1.751.817 3.296 2.072 4.328.19-.494.552-1.01 1.252-1.369 0-.002.012-.002.02-.002A3.736 3.736 0 0 1 8 10.75a3.75 3.75 0 1 1 7.5 0c0 1.208-.58 2.27-1.468 2.956.005.001.02.002.019.003.7.358 1.062.874 1.252 1.369 1.256-1.031 2.072-2.578 2.072-4.328"
    />
  </svg>
)
export default SvgApplePodcast
